<template>
  <div :class="$style.container">
    <el-row>
      <el-col :span="2" style="height: 1px"></el-col>
      <el-col :span="20" :class="$style.header">
        <div :class="$style.left" style="position: relative">
          <img :src="LOGO" alt="" v-if="status" style="position: absolute; top: -15px" width="100" />
          <img :src="LOGO" alt="" v-if="!status" style="position: absolute; top: 15px" width="100" />
        </div>
        <div :class="$style.right" v-if="status">
          <!--                    <ul style="position: relative;z-index: 999">-->
          <!--                        <li style="position: relative" v-if="item.parent_menu == ''" :class="[$style.item, activeName ===-->
          <!--                        item.menu_name ?-->
          <!--                        $style.active: '']"-->
          <!--                            v-for="item in lists" :key="item" @click.stop="changeActiveName(item.menu_name)"-->
          <!--                        >{{item.menu_name}}-->
          <!--                            <div v-if="item.children.length>0"-->
          <!--                                 :style="{height:top,opacity:opacity,boxShadow:boxShadow}"-->
          <!--                                 style="-moz-border-radius-bottomright: 2px;-moz-border-radius-bottomleft: 2px;-->
          <!--                                 ;position: absolute;z-index: 99;width: 100%;background: white;transition:.2s;overflow: hidden;top: 62px" >-->
          <!--                               <p @click="peopleRouter(obj)" v-for="obj in item.children"-->
          <!--                                  class="pTow"-->
          <!--                                  style="height: 30px;margin: 0;padding: 0;line-height: 30px;text-decoration:none"><a-->
          <!--                                       @click.prevent="aStop()"-->
          <!--                                       href="" class="pTowA">{{obj.menu_name}}</a></p>-->
          <!--                            </div>-->
          <!--                        </li>-->
          <!--                    </ul>-->

          <el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <label id="label" v-for="(item, index) in lists" :key="index" style="height: 60px">
              <el-menu-item @click="changeActiveName(item)" :index="index" v-if="item.children.length === 0"
                style="height: 60px">{{ item.menu_name }}</el-menu-item>
              <el-submenu :index="index" v-else style="height: 60px">
                <template slot="title">{{ item.menu_name }}</template>
                <el-menu-item @click="changeActiveName(obj)" :index="index + '-' + (k + 1)"
                  v-for="(obj, k) in item.children" :key="k"> {{ obj.menu_name }}</el-menu-item>
              </el-submenu>
            </label>
          </el-menu>

          <!--                    <div style="margin-left:10px;overflow: hidden;-->
          <!--                    margin-right: 5px;font-size: 14px;height:60px;line-height: 56px"-->
          <!--                        >-->
          <!--                        <div style="float: left">-->
          <!--                            <div style="float: left">-->
          <!--                                <div style="width: 20px;height: 20px;border-radius: 50%;-->
          <!--                           margin-top: 18px;overflow: hidden;position: relative;margin-right: 10px">-->
          <!--                                    <img :src="userPhoto" alt="" style="width: 100%;height: 100%;-->
          <!--                                    object-fit: cover;position: absolute;-->
          <!--                                        top:50%;left:50%;transform: translate(-50%,-50%);">-->
          <!--                                </div>-->
          <!--                            </div>-->
          <!--                            <span v-text="userName" style="margin-right: 20px;color: #ff9901"></span>-->
          <!--                        </div>-->

          <!--                        <i  @click.stop="handleLogoutClick" style="float: right" :class="['iconfont', 'icon-square_right', $style.arrow]"></i>-->
          <!--                    </div>-->
          <div style="
              display: flex;
              justify-content: center;
              align-items: center;
              margin-left: 10px;
            ">
            <div style="position: relative; top: -3px" @click.stop="showPwdModel">
              <img :src="userPhoto" style="width: 20px; height: 20px; border-radius: 50%" />
            </div>
            <div style="
                display: flex;
                flex-direction: column;
                justify-content: center;
                margin: 0 20px 0 15px;
                position: relative;
                top: -4px;
              ">
              <span style="color: #ff9901; font-size: 15px; margin-bottom: 4px">{{ userName }}</span>
              <span @click.stop="handleSelectTenant" style="color: #59a8f9; font-size: 12px">{{ tenant_name }} <i
                  class="el-icon-arrow-down"></i></span>
            </div>
            <i @click.stop="handleLogoutClick" style="position: relative; top: -3px"
              :class="['iconfont', 'icon-square_right', $style.arrow]"></i>
          </div>
        </div>
      </el-col>
      <el-col :span="2"></el-col>
    </el-row>
    <el-dialog title="" :visible.sync="mdfPwdModel" :show-close="false">
      <div slot="title" class="dialog-footer" style="display: flex;justify-content:space-between;
                 border-bottom: 2px dashed #e7eaec;padding:10px 0px">
        <span style="color: #3998F7;font-size: 22px;padding-top: 5px">修改密码</span>
        <span>
          <el-button @click="saveUserPwd" type="primary" size="small">保存</el-button>
          <el-button type="danger" @click="closePwdModel" size="small">取消</el-button>
        </span>
      </div>
      <el-form class="formSave" :model="mdfUserPwd" style="width: 80%;margin: auto" ref="addFormStore"
        label-position="left" hide-required-asterisk>
        <el-form-item label="旧密码">
          <el-input v-model="mdfUserPwd.oldpwd"></el-input>
        </el-form-item>
        <el-form-item label="新密码">
          <el-input v-model="mdfUserPwd.newpwd"></el-input>
        </el-form-item>
        <el-form-item label="确认新密码">
          <el-input v-model="mdfUserPwd.newpwd2"></el-input>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="dialogSelectTenant" width="700px" :show-close="false" style="vertical-align: center; "
      custom-class="dialogSty">
      <div style="margin-top: -40px" class="dialogLoginReset">
        <el-row>
          <el-col :span="12">
            <div style="
              color: #3998f7;
              padding-top: 8px;
              font-size: 20px;
              text-align: left;
            ">
              选择租户
            </div>
          </el-col>

          <el-col :span="12">
            <div align="right">
              <el-button type="danger" size="small" @click="dialogSelectTenant = false">
                关闭
              </el-button>
            </div>
          </el-col>
        </el-row>
        <div style="
          margin-top: 20px;
          height: 400px;
          position: relative;
          text-align: left;
          overflow: auto;
        ">
          <div v-for="(item, index) in tenants" :key="index" style="width: 60%; margin: 20px auto; overflow: hidden">
            <p style="
              width: 300px;
              display: inline-block;
              overflow: hidden;
              word-wrap: break-word;
              word-break: normal;
              text-overflow: ellipsis;
              white-space: nowrap;
            ">
              {{ item.tenant_name }}
            </p>
            <el-button type="primary" size="small" style="float: right; margin-top: 5px" @click="onIntoThe(item)">
              立即切换
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import http from "../APIService/http";
  import { bus } from "../router/index.js";
  import favicon from "../assets/images/favicon.svg";
  import photoHead from "../assets/images/defaultHead.png";
  export default {
    props: {
      status: {
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        activeIndex: 7,
        activeName: "资料库",

        // lists: ['考勤', '巡店', '服务工单','门店管理' ,'资料库', '报表']
        //lists: ['资料库','系统']
        lists: [],
        top: "0px",
        opacity: 0,
        boxShadow: "none",
        img: favicon,
        userPhoto: "",
        userName: "",
        tenant_name: "",
        mdfPwdModel: false,
        dialogSelectTenant: false,
        tenants: [],
        obj: {},
        TITLE: "",
        DOWNLOAD: false,
        LOGO: "",
        mdfUserPwd: {
          oldpwd: "",
          newpwd: "",
          newpwd2: "",
        },
      };
    },
    watch: {
      status(val) {
        if (val === true) {
          this.getUserPhoto();
        }
      },
    },
    created() {
      this.init(this.$store.getters.getUser);
      this.getTenantInfo();
      this.getUserPhoto();
      this.getParametersList();
      this.getTenantList();
      let currentPath = this.$router.history.current.fullPath;

      if (/^\/attendance/.test(currentPath)) {
        this.activeName = "考勤";
      } else if (/^\/cruiseShop/.test(currentPath)) {
        this.activeName = "巡店";
      } else if (/^\/stores/.test(currentPath)) {
        this.activeName = "门店管理";
      } else if (/^\/database/.test(currentPath)) {
        this.activeName = "资料库";
      } else if (/^\/serviceWorkOrder/.test(currentPath)) {
        this.activeName = "服务工单";
      } else if (/^\/workOrderInfo/.test(currentPath)) {
        this.activeName = "服务工单";
      } else if (/^\/report/.test(currentPath)) {
        this.activeName = "报表";
      } else if (/^\/system/.test(currentPath)) {
        this.activeName = "系统";
      } else if (/^\/system/.test(currentPath)) {
        this.activeName = "流向数据";
      } else if (/^\/system/.test(currentPath)) {
        this.activeName = "分销客户";
      } else if (/^\/Territorymanagement/.test(currentPath)) {
        this.activeName = "辖区管理";
      } else if (/^\/dashboard/.test(currentPath)) {
        this.activeName = "DASHBOARD";
      }
      // else if (/^\/store/.test(currentPath)) {
      //     this.activeName = '渠道管理'
      // }
      // else if (/^\/setting/.test(currentPath)) {
      //     this.activeName = '系统管理'
      // }
      this.getTerritoryList();
    },
    methods: {
      getTerritoryList() {
        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            user_id: user.user_id,
          };
          http.post("/wapi/Collect/getTerritoryList", data).then((res) => {
            if (res.success == true) {
              localStorage.setItem("territoryList", JSON.stringify(res.data));
            }
          });
        } catch (e) { }
      },
      getParametersList() {
        try {
          let user = this.$store.getters.getUser;
          let data = {
            product_version: "0.1.0",
            product_id: "CRM",
          };
          http.post("/yp/parameters/getParametersList", data).then((res) => {
            if (res.success == true) {
              //编写信息
              for (let i in res.data) {
                if (res.data[i].parameter_id == "SYSTEM_TITLE") {
                  this.TITLE = res.data[i].parameter_name;
                } else if (res.data[i].parameter_id == "SYSTEM_WEB_LOGO") {
                  this.LOGO = res.data[i].parameter_value;
                } else if (res.data[i].parameter_id == "ENABLE_LOGIN_APP_DOWNLOAD") {
                  this.DOWNLOAD = res.data[i].parameter_value == "T" ? true : false;
                }
              }
            }
          });
        } catch (e) { }
      },
      showPwdModel() {
        this.mdfPwdModel = true;
        this.mdfUserPwd.oldpwd = "";
        this.mdfUserPwd.newpwd = "";
        this.mdfUserPwd.newpwd2 = "";
      },

      closePwdModel() {
        this.mdfPwdModel = false;
        this.mdfUserPwd.oldpwd = "";
        this.mdfUserPwd.newpwd = "";
        this.mdfUserPwd.newpwd2 = "";
      },
      handleSelectTenant() {
        this.dialogSelectTenant = true;
      },
      async saveUserPwd() {
        try {
          if (!this.mdfUserPwd.newpwd) {
          } else if (!this.mdfUserPwd.newpwd2) {
          } else if (this.mdfUserPwd.newpwd != this.mdfUserPwd.newpwd2) {
          }

          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            user_id: user.user_id,
            oldpwd: this.mdfUserPwd.oldpwd,
            newpwd: this.mdfUserPwd.newpwd,
          };

          await http.post("/crm/users/admin/mdfUserPwd", data).then((res) => {
            if (res.code != 1000) {
              return this.$message.error(res.message);
            } else {
              this.mdfPwdModel = false;
              return this.$message.success("修改密码成功");
            }
          });
        } catch (e) { }
      },
      handleLogoutClick() {
        localStorage.setItem("active", 1);
        this.GLOBAL.territory_id = "";
        this.GLOBAL.date = "";
        this.activeName = "LIBRARY";

        this.$router.push({
          path: "/login",
        });
      },
      changeActiveName(item) {
        console.log(item);

        this.activeName = item.menu_type;

        if (this.activeName === "CALENDAR") {
          this.$router.push({
            path: "/calendar/calendarTable",
          });
        } else if (this.activeName === "门店管理") {
          this.$router.push({
            path: "/stores/area",
          });
        } else if (this.activeName === "LIBRARY") {
          this.$router.push({
            path: "/library/index",
          });
        } else if (this.activeName === "SETTINGS") {
          this.$router.push({
            path: "/system/roles",
          });
        } else if (this.activeName === "分销客户") {
          this.$router.push({
            path: "/system/roles",
          });
        } else if (this.activeName === "OU") {
          this.$router.push({
            path: "/organization",
          });
        } else if (this.activeName === "TERRITORY") {
          this.$router.push({
            path: "/territory/index",
          });
        } else if (this.activeName === "流向数据") {
          this.$router.push({
            path: "/system/roles",
          });
        } else if (this.activeName === "DEVOPS") {
          this.$router.push({
            path: "/systemDevelop",
          });
        } else if (this.activeName === "SERVICE") {
          this.$router.push({
            path: "/service",
          });
        } else if (this.activeName === "CLIENT") {
          this.$router.push({
            path: "/clients/index",
          });
        } else if (this.activeName === "SALES_CZ_DATA") {
          this.$router.push({
            path: "/changzhou_set",
          });

          // window.location.reload();
        } else if (this.activeName === "ACCOUNTS_PROFILE") {
          this.$router.push({
            path: "/files/index",
          });
        } else if (this.activeName === "ACCOUNTS") {
          this.$router.push({
            path: "/files/index",
          });
          // window.location.reload();
        } else if (this.activeName === "ACCOUNTS_LIST") {
          this.$router.push({
            path: "/target/index",
          });
        } else if (this.activeName === "PRODUCT") {
          this.$router.push({
            path: "/product",
          });
        } else if (this.activeName === "PRODUCT_GROUP") {
          this.$router.push({
            path: "/productgroup",
          });
        } else if (this.activeName === "ACCOUNTS_APPROVAL") {
          this.$router.push({
            path: "/pending",
          });
        } else if (this.activeName === "SALES") {
          let database = this.$store.getters.getUser.database;
          if (database == "spb2b") {
            this.$router.push({
              path: "/salesDataB2B",
            });
          } else {
            this.$router.push({
              path: "/salesdata",
            });
          }
        }  else if (this.activeName === "CSO_SALES") {
          this.$router.push({
              path: "/cso_salesdata",
            });
        } else if (this.activeName === "SALES_DATA") {
          this.$router.push({
            path: "/salesManagement",
          });
        }  else if (this.activeName === "CSO_SALES_DATA") {
          this.$router.push({
            path: "/cso_salesManagement",
          });
        } else if (this.activeName === "NETWORK_PROFILE") {
          this.$router.push({
            path: "/Territorymanagement",
          });
        } else if (this.activeName === "NETWORK_LIST") {
          this.$router.push({
            path: "/jurmanageChange",
          });
        } else if (this.activeName === "NETWORK_APPROVAL") {
          this.$router.push({
            path: "/jurmanageApproval",
          });
        } else if (this.activeName === "TASK") {
          this.$router.push({
            path: "/task",
          });
        } else if (this.activeName === "REPORTS") {
          this.$router.push({
            path: "/statement/overview",
          });
          localStorage.setItem("tabActive", 0);
        } else if (this.activeName === "DASHBOARD") {
          this.$router.push({
            path: "/dashboard",
          });
        } else if (this.activeName === "INFO_COLLECTION") {
          this.$router.push({
            path: "/collectionHome",
          });
        } else if (this.activeName === "ACCOUNTS_INFO_COLLECTION") {
          this.$router.push({
            path: "/customCollect",
          });
        } else if (this.activeName === "LUOSHI_INFO_COLLECTION") {
          this.$router.push({
            path: "/luoshiCustomCollect",
          });
        }  else if (this.activeName === "LUOSHI_ADDCUSTOM_COLLECTION") {
          this.$router.push({
            path: "/luoshiAddCustomCollect",
          });
        }   else if (this.activeName === "LUOSHI_COLLECTION_REPORT") {
          this.$router.push({
            path: "/luoshiReportProgressCollect",
          });
        }   else if (this.activeName === "BOJIAN_COLLECTION_REPORT") {
          this.$router.push({
            path: "/bojianReportProgressCollect",
          });
        } else if (this.activeName === "HOME") {
          this.$router.push({
            path: "/home",
          });
        } else if (this.activeName === "DEPARTMENT") {
          this.$router.push({
            path: "/standard",
          });
        } else if (this.activeName === "PROJECT") {
          this.$router.push({
            path: "/Project",
          });
        } else if (this.activeName === "SPEAKER") {
          this.$router.push({
            path: "/Speaker",
          });
        } else if (this.activeName === "REGION") {
          this.$router.push({
            path: "/regionCheck",
          });
        } else if (this.activeName === "ECHO_LIBRARY_COLLECTION") {
          this.$router.push({
            path: "/albumManage",
          });
        } else if (this.activeName === "ECHO_LIBRARY_TAG") {
          this.$router.push({
            path: "/TagManage",
          });
        } else if (this.activeName === "ECHO_LIBRARY_PUBLISH") {
          this.$router.push({
            path: "/echoLibraryIndex",
          });
        } else if (this.activeName === "ECHO_COMPLIANCE") {
          this.$router.push({
            path: "/echoCompliance",
          });
        } else if (this.activeName === "ECHO_LIBRARY_BULK_SEND") {
          this.$router.push({
            path: "/echoLibraryBulk",
          });
        }
        console.log(this.activeName);
        // else if (this.activeName === '渠道管理') {
        //     this.$router.push({
        //         //path: '/store/index'
        //         path: '/store/region'
        //
        //     })
        // }else if (this.activeName === '系统管理') {
        //     this.$router.push({
        //         // path: '/setting'
        //         path: '/setting/settingOu'
        //
        //     })
        // }
      },
      handleSelect(i) {
        window.localStorage.setItem("activeIndex", i);
      },
      async init(data) {
        await http.post("/wapi/v1/navHeader", data).then((res) => {
          // if (res.data.length > 0){
          //     let menu = res.data
          //     let arrF = []
          //     let arrS = []
          //     menu.forEach(item=>{
          //         item.children = []
          //         if (!item.parent_menu) {
          //             arrF.push(item)
          //         }else {
          //             arrS.push((item))
          //         }
          //     })
          //     console.log(menu)
          //     for (let i =0;i<arrS.length;i++){
          //
          //         for (let j =0;j<arrF.length;j++){
          //             if (arrS[i].parent_menu === arrF[j].menu_id){
          //                 arrF[j].children.push(arrS[i])
          //                 break
          //             }
          //         }
          //     }
          //     this.lists=arrF
          // }
          if (res.data.length > 0) {
            let data = [];
            data = res.data;
            data.sort((a, b) => {
              return a.sort - b.sort;
            });
            this.lists = data;

            let i = -1;
            if (this.lists.length > 0) {
              this.lists.forEach((item) => {
                if (!item.parent_menu) {
                  i++;
                }
              });
              let j = window.localStorage.getItem("activeIndex");
              this.activeIndex = j;
              window.localStorage.setItem("activeIndex", j);
              // if (this.lists[i].menu_name === '人员/辖区'){
              //     this.activeIndex = i+'-1'
              // } else if (this.lists[i].menu_name === 'CLM+'){
              //     this.activeIndex = i+'-1'
              // }
            }
          }
        });
        bus.$on("navRole", (e) => {
          e.sort((a, b) => {
            return a.sort - b.sort;
          });
          this.lists = e;
          // let i=-1
          // if (this.lists.length>0){
          //     this.lists.forEach(item=>{
          //         if (!item.parent_menu) {
          //             i++
          //         }
          //     })
          //     this.activeIndex=i
          //     if (this.lists[i].menu_name === '人员/辖区'){
          //         this.activeIndex = i+'-1'
          //     } else if (this.lists[i].menu_name === 'CLM+'){
          //         this.activeIndex = i+'-1'
          //     }
          // }
          bus.$on("inactiveNav", (i) => {
            this.activeIndex = i;

            window.localStorage.setItem("activeIndex", i);
          });
        });
      },

      async resetHeader(data) {
        await http.post("/wapi/v1/navHeader", data).then((res) => {
          if (res.data.length > 0) {
            this.getShow(data).then((r) => {
                this.list = res.data
                this.list.sort((a, b) => {
                  return a.sort - b.sort
                })
                bus.$emit('navRole', this.list)
              })
          }
        });
      },
      async getShow(data) {
        try {
          await http.post('/wapi/login/getShow', data).then((res) => {
            if (res.success == true) {
              this.$store.commit('setClient', res.data)
            }
          })
        } catch (e) {
          //console.log(e);
        }
      },
      async getUserPhoto() {
        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            user_id: user.user_id,
          };

          await http.post("/wapi/v1/getUserPhoto", data).then((res) => {
            if (res.data.photo_id) {
              this.getImgUrl(res.data.photo_id);
            } else if (res.data.photo_url) {
              this.userPhoto = res.data.photo_url;
            } else {
              this.userPhoto = photoHead;
            }
            this.userName = res.data.last_name;
            // this.tenant_name = res.data.tenant_name;
          });
        } catch (e) { }
      },
      async getTenantInfo() {
        try {
          let user = this.$store.getters.getUser;
          let data = {
            tenant_id: user.tenant_id,
            product_id: "CRM",
          };

          await http.post("/yp/tenants/getTenantInfo", data).then((res) => {
            console.log("------res---------");
            console.log(res);
            this.tenant_name = res.tenant_name;
            console.log("------tenant_name---------");
            console.log(this.tenant_name);
          });
        } catch (e) { }
      },
      async getImgUrl(id) {
        try {
          let data = {
            reference_obj: "INSTITUTION",
            reference_id: "com.saasyun.android",
            credential: "0a4da4e6-e36a-4e78-b4fc-78bb62aa9ff4",
            photo_ids: id,
            tenant_id: this.$store.getters.getUser.tenant_id,
          };

          let res = await http.post("/photos/downloadphotos", data);
          let array = res.data;

          if (array.length > 0) {
            this.userPhoto = array[0].thu_url;

            this.$forceUpdate();
          }
        } catch (err) {
          console.log(`error:${err}`);
        }
      },
      async getTenantList() {
        this.tenants = []
        let _paras = {
          product_id: 'CRM',
          tenant_type: 'CRM',
          client_id: 'com.saasyun.web',
          username: this.$store.getters.getUser.phone
        }

        console.log(_paras)
        // let tenants = await http.post('/yellow_page/getTenantsByUsername', _paras)
        let tenants = await http.post('/yp/tenants/getTenantsByUsername', _paras)

        if (!tenants.success) {
          this.$message.error('租户列表获取失败')
          return;
        }
        this.tenants = tenants.data;

      },
      async onIntoThe(item) {
        try {
          let data = {
                phone: this.$store.getters.getUser.phone || '',
                tenant_id: item.tenant_id || '',
              }
              
          //console.log(data);
          let userObj
          this.loading = true
          let res = await http.post('/wapi/v1/login', data)
          //console.log(res);

          if (res.success) {
            this.obj = userObj = res.data
          } else {
            this.loading = false
            this.$message.error("切换租户失败")
            return
          }
          
          console.log(userObj)
          this.$store.commit('setUser', userObj)
          // this.rolePage(userObj)
          this.resetHeader(userObj)
          this.getParametersList();
          var obj = { index: true }
          this.$store.commit('setStoreChange', obj)

          this.dialogSelectTenant = false;
          window.location.reload()

        } catch (err) {
          this.loading = false
          this.error(err)
        }
      },
      aStop() {
        return false;
      },
      peopleRouter(obj) {
        this.$router.push({
          path: "/territory/index",
        });
        this.$nextTick(function () {
          this.top = "0px";
          this.boxShadow = "none";
        });
      },
    },
  };
</script>
<style lang="scss" module>
  .container {
    background: #ffffff;
    border: 1px solid #e7eaec;
    height: 61px;
    /*line-height: 60px;*/
    z-index: 10;

    .header {
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      justify-content: space-between;
      align-items: center;
      width: 100%;

      .left {
        font-family: PingFangSC-Semibold;
        font-size: 16px;
        color: #3998f7;
        text-align: left;
        margin-left: 75px;

        span {
          color: black;
          font-size: 12px;
        }

        em {
          font-size: 16px;
        }
      }

      .right {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        margin-right: 75px;

        ul {
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;

          .item {
            margin: 0 10px;
            width: 70px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #323232;
            text-align: center;
            cursor: pointer;
          }

          .active {
            border-bottom: 2px solid #3998f7;
          }

          .inactive {
            border-bottom: 2px solid transparent;
          }
        }

        .arrow {
          color: #f45c50;
          font-size: 16px;
          cursor: pointer;
        }
      }
    }
  }
</style>

<style>
  .pTow:hover {
    background: #3b99f7;
  }

  .pTowA {
    color: black;
  }

  .pTow:hover .pTowA {
    color: white;
  }

  .el-submenu__title {
    height: 59px;
  }

  .el-submenu.is-opened>.el-submenu__title .el-submenu__icon-arrow {
    background: transparent;
    color: transparent;
  }

  .el-submenu__icon-arrow.el-icon-arrow-down {
    background: transparent;
    color: transparent;
  }

  #label>.is-active {
    border-bottom: 2px solid #3998f7;
  }

  #label .el-submenu__title {
    height: 60px;
  }

  .el-menu--popup {
    min-width: 120px !important;
  }
</style>


// WEBPACK FOOTER //
// src/components/navHeader.vue